<template>
  <div>
    <h1>Agent extend</h1>
    <form action="" @submit.prevent="handleSubmit" v-if="adDetails">
      <div class="form-group">
        <div>
          <input
            type="text"
            id="title"
            class="form-control"
            v-model="adDetails.title"
            placeholder="Enter Ad Title"
          />
          <p class="validation-error-message" v-if="validationErrors.title">
            {{ validationErrors.title[0] }}
          </p>
        </div>
        <label for="title">Ad Title:</label>
      </div>

      <div class="d-flex my-4">
        <div class="mr-4" v-if="adDetails.mainImage">
          <p style="text-transform: uppercase; font-weight: bold;">
            Main Image:
          </p>
          <ImageGrid
            :imageUrl="adDetails.mainImage.url"
            id="main-image-file"
            imageKey="mainImageUrl"
            @on-image-updated="handleImageUpdated"
            :error="
              validationErrors && validationErrors['mainImage.url']
                ? validationErrors['mainImage.url'][0]
                : null
            "
          ></ImageGrid>
        </div>
        <div>
          <p style="text-transform: uppercase; font-weight: bold;">
            Agent Image:
          </p>
          <ImageGrid
            id="agent-image-file"
            :imageUrl="adDetails.agentImageUrl"
            imageKey="agentImageUrl"
            @on-image-updated="handleImageUpdated"
            :error="
              validationErrors && validationErrors['agentImageUrl']
                ? validationErrors['agentImageUrl'][0]
                : null
            "
          ></ImageGrid>
        </div>
      </div>

      <div class="form-group">
        <div>
          <input
            type="tel"
            id="agentPhone"
            class="form-control"
            v-model="adDetails.agentPhone"
            placeholder="Enter Agent Phone"
          />
          <p
            class="validation-error-message"
            v-if="validationErrors.agentPhone"
          >
            {{ validationErrors.agentPhone[0] }}
          </p>
        </div>
        <label for="agentPhone">Agent Phone:</label>
      </div>
      <div class="form-group">
        <div>
          <input
            type="text"
            id="agentExtendTargetPostcodes"
            class="form-control"
            v-model="adDetails.agentTargetPostcodes"
            placeholder="Enter Agent Extend Target Postcodes"
          />
          <p
            class="validation-error-message"
            v-if="validationErrors.agentTargetPostcodes"
          >
            {{ validationErrors.agentTargetPostcodes[0] }}
          </p>
        </div>
        <label for="agentExtendTargetPostcodes"
          >Agent extend target post code:</label
        >
      </div>
      <div class="form-group">
        <div>
          <input
            type="text"
            id="url"
            class="form-control"
            v-model="adDetails.destinationUrl"
            placeholder="Enter Destination URL"
          />
          <p
            class="validation-error-message"
            v-if="validationErrors.destinationUrl"
          >
            {{ validationErrors.destinationUrl[0] }}
          </p>
        </div>
        <label for="url">Destination URL:</label>
      </div>

      <div class="mt-4" v-if="videoUrl">
        <p style="text-transform: uppercase; font-weight: bold;">Video:</p>
        <div class="form-group" v-if="videoUrl">
          <div>
            <input
              type="text"
              class="form-control"
              :value="videoUrl"
              readonly
            />
          </div>
          <label>Current Video URL:</label>
        </div>
        <div class="row" style="margin-top: 10px" v-if="videoUrl">
          <div class="col-4">
            <video-upload
              :video="video"
              :displayLabel="false"
              :handleFileChange="handleVideoFileChange"
              ref="videoRef"
            />
          </div>
        </div>
        <div v-if="videoSizeError" style="color: red; font-size: 14px;">
          {{ VIDEO_ERROR_MESSAGES.MAX_SIZE }}
        </div>
        <div v-if="videoFileTypeError" style="color: red; font-size: 14px;">
          {{ VIDEO_ERROR_MESSAGES.FILE_TYPE }}
        </div>
        <p style="font-size: 12px;">MP4 only, max 1GB</p>
      </div>

      <button type="submit" class="btn btn-primary mt-3">
        Save Changes
      </button>
    </form>
    <app-modal-progress-bar
      v-if="progress['saveAdDetails'].visible"
      :progress="progress['saveAdDetails'].progress"
      :label="progress.label"
      :state="progress.state"
    ></app-modal-progress-bar>
    <app-modal-progress-bar
      :state="videoUploadProgress.state"
      :progress="videoUploadProgress.progress"
      :label="videoUploadProgress.label"
      :onCancel="onCancelVideoUpload"
      v-if="videoUploadProgress.visible"
    ></app-modal-progress-bar>
  </div>
</template>
<script>
import axios from 'axios';
import ImageGrid from './ImageGrid.vue';
import AppModalProgressBar from '../../AppComponents/Loaders/AppModalProgressBar.vue';
import VideoUpload from '../../../helpers/VideoUpload';
import CampaignServiceV2 from '../../../services/V2/CampaignServiceV2';
import ProgressState from '../../../mixins/ProgressState';
import {VIDEO_ERROR_MESSAGES, VIDEO_LIMITS} from '../../../configs/videoLimits';

export default {
  props: ['campaignId'],
  mixins: [ProgressState],
  components: {
    ImageGrid,
    AppModalProgressBar,
    VideoUpload,
  },
  created() {
    this.registerLoader('saveAdDetails');
  },
  mounted() {
    this.getCampaignAdListingDetails();
  },
  data() {
    return {
      adDetails: null,
      progress: {
        label: 'Saving ad listing details...',
        state: 'loading',
      },
      validationErrors: {},
      video: null,
      videoSizeError: false,
      videoFileTypeError: false,
      VIDEO_ERROR_MESSAGES: VIDEO_ERROR_MESSAGES,
      VIDEO_LIMITS: VIDEO_LIMITS,
      videoUploadProgress: {
        progress: 0,
        visible: false,
        label: 'Uploading your video, please wait...',
        state: 'loading',
      },
      videoUploadController: null,
      videoUrl: null,
    };
  },
  methods: {
    getCampaignAdListingDetails() {
      CampaignServiceV2.getCampaignAdListingDetails(this.campaignId).then(
        (response) => {
          this.adDetails = response.data.data;
          this.videoUrl = this.adDetails.videoUrl || null;
        }
      );
    },
    handleImageUpdated(data) {
      if (data.imageKey === 'agentImageUrl') {
        this.handleAgentImageUpdated(data);
        return;
      }
      this.handleMainImageUpdated(data);
    },
    handleMainImageUpdated(data) {
      this.adDetails.mainImage.url = data.imageUrl;
    },
    handleAgentImageUpdated(data) {
      this.adDetails.agentImageUrl = data.imageUrl;
    },
    validateVideo() {
      this.videoSizeError = false;
      this.videoFileTypeError = false;

      if (!(this.video instanceof File)) return true;

      if (this.video.size > VIDEO_LIMITS.MAX_SIZE) {
        this.videoSizeError = true;
        return false;
      }

      if (
        this.video.type !== 'video/mp4' ||
        !this.video.name.toLowerCase().endsWith('.mp4')
      ) {
        this.videoFileTypeError = true;
        return false;
      }

      return true;
    },
    onCancelVideoUpload() {
      if (this.videoUploadController) {
        this.videoUploadController.abort();
        this.videoUploadController = null;
      }
      this.videoUploadProgress.visible = false;
      this.videoUploadProgress.progress = 0;
      this.videoUploadProgress.state = 'loading';
      this.videoUploadProgress.label = 'Uploading your video, please wait...';
      this.video = null;
      this.videoUrl = null;
      if (this.$refs.videoRef) {
        this.$refs.videoRef.clearVideo();
      }
    },
    async handleVideoFileChange(file) {
      if (this.videoUploadController) {
        this.videoUploadController.abort();
        this.videoUploadController = null;
      }

      this.videoUploadController = new AbortController();
      this.video = file;

      if (!this.validateVideo()) {
        this.videoUploadController = null;
        return;
      }

      this.videoSizeError = false;
      this.videoFileTypeError = false;
      this.videoUploadProgress.visible = true;
      this.videoUploadProgress.state = 'loading';
      this.videoUploadProgress.progress = 0;
      this.videoUploadProgress.label = 'Uploading your video, please wait...';

      try {
        const presignedData = await CampaignServiceV2.getUploadPresignedUrl(file.name);

        await CampaignServiceV2.uploadBinaryToPresignedUrl(
          presignedData.data.url,
          file,
          (progress) => {
            if (progress < 95) this.videoUploadProgress.progress = progress;
          },
          this.videoUploadController
        );

        await CampaignServiceV2.registerVideo({
          filename: presignedData.data.filename,
        });

        const rawUrl = presignedData.data.url;
        const mp4Index = rawUrl.indexOf('.mp4');
        this.videoUrl = mp4Index !== -1 ? rawUrl.substring(0, mp4Index + 4) : rawUrl;
        this.videoUploadProgress.progress = 100;
        this.videoUploadProgress.state = 'loaded';
        this.videoUploadProgress.label = 'Video upload successful.';
      } catch (error) {
        if (
          error.name === 'AbortError' ||
          error.message.includes('aborted') ||
          error.code === 'ERR_CANCELED' ||
          axios.isCancel(error) ||
          error.message.includes('cancelled') ||
          error.message === 'Upload cancelled by user'
        ) {
          this.videoUploadProgress.state = 'cancelled';
          this.videoUploadProgress.label = 'Video upload cancelled.';
          setTimeout(() => {
            this.videoUploadProgress.visible = false;
          }, 1000);
          return;
        }

        this.video = null;
        this.$refs.videoRef.clearVideo();
        this.videoUploadProgress.state = 'error';
        this.videoUploadProgress.label = 'Video upload failed. Please try again.';
        setTimeout(() => {
          this.$refs.videoRef.clearVideo();
        }, 2000);
      } finally {
        if (this.videoUploadController) {
          this.videoUploadController = null;
        }
        setTimeout(() => {
          if (this.videoUploadProgress.state !== 'cancelled') {
            this.videoUploadProgress.visible = false;
          }
        }, 2000);
      }
    },
    handleSubmit() {
      this.startProgress('saveAdDetails');
      this.progress.state = 'loading';
      this.progress.label = 'Saving ad listing details...';
      this.validationErrors = {};
      const formattedAdDetails = {
        ...this.adDetails,
        description: "",
        ...(this.videoUrl ? {videoUrl: this.videoUrl} : {}),
      };

      CampaignServiceV2.updateCampaignAdListingDetails(
        this.campaignId,
        formattedAdDetails
      )
        .then(() => {
          this.endProgress('saveAdDetails');
          this.progress.label = 'Ad listing details saved successfully!';
          this.getCampaignAdListingDetails();
          setTimeout(() => {
            this.closeProgress('saveAdDetails');
          }, 1000);
        })
        .catch((error) => {
          const status = error.response.status;

          if (status === 422) {
            this.validationErrors = error.response.data.errors;

            // Check if any imageList validation errors exist
            const hasImageListErrors = Object.keys(this.validationErrors).some(
              (key) => key.startsWith('imageList.')
            );
            if (hasImageListErrors) {
              this.validationErrors.imageList = Object.keys(
                this.validationErrors
              )
                .filter((key) => key.startsWith('imageList.'))
                .reduce((acc, key) => {
                  const formattedKey = key.split('.')[1];
                  acc[formattedKey] = this.validationErrors[key][0];
                  return acc;
                }, {});
            }

            this.progress.label =
              'Validation error encountered, please review the form.';
          } else {
            this.progress.label =
              'Error saving ad listing details. Please try again.';
          }

          this.progress.state = 'error';
          this.endProgress('saveAdDetails');
          setTimeout(() => {
            this.closeProgress('saveAdDetails');
          }, 3000);
        });
    },
  },
};
</script>

<style scoped>
.validation-error-message {
  font-size: 14px;
  color: red;
}
</style>
